export default "__VITE_ASSET__Bp8Awps___"